import { render, staticRenderFns } from "./dialog-confirmEmptyTrashAll-outbox.vue?vue&type=template&id=e351783c&"
import script from "./dialog-confirmEmptyTrashAll-outbox.vue?vue&type=script&lang=js&"
export * from "./dialog-confirmEmptyTrashAll-outbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports